import { Box } from "@chakra-ui/react";
import { BorderLeft } from "@mui/icons-material";

const CategorySize = () => {
  const styles = {
    container: {
      padding: '24px',
      fontFamily: 'Arial, sans-serif',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '24px',
    },
    section: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '20px',
    },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      marginBottom: '16px',
      color: '#333',
    },
    filterGroup: {
      marginBottom: '24px',
    },
    filterTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '12px',
    },
    chipGroup: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
    },
    chip: {
      padding: '6px 12px',
      borderRadius: '16px',
      fontSize: '14px',
      cursor: 'pointer',
      border: 'none',
    },
    activeChip: {
      backgroundColor: '#4a4a4a',
      color: 'white',
    },
    inactiveChip: {
      backgroundColor: '#e0e0e0',
      color: '#333',
    },
    regionTable: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    tableHeader: {
      textAlign: 'left',
      padding: '8px',
      fontSize: '14px',
      color: '#666',
    },
    tableCell: {
      padding: '8px',
      fontSize: '14px',
    },
    checkbox: {
      width: '18px',
      height: '18px',
    },
    formula: {
      backgroundColor: '#e8f4ff',
      padding: '16px',
      borderRadius: '8px',
    },
    formulaTitle: {
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '12px',
    },
    formulaItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '6px',
      backgroundColor: 'white',
      borderRadius: '4px',
      marginBottom: '8px',
    },
    closeButton: {
      padding: '2px 6px',
      backgroundColor: '#ddd',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    barChart: {
      width: '100%',
      marginTop: '16px',
    },
    bar: {
      height: '24px',
      backgroundColor: '#d4d6ff',
      marginBottom: '8px',
      borderRadius: '4px',
    },
    barLabel: {
      fontSize: '14px',
      marginBottom: '4px',
    }
  };

  const trendData = [
    { year: '1999-00', value: 0.2, femaleValue: 0.1 },
    { year: '2004-05', value: 0.5, femaleValue: 0.3 },
    { year: '2009-10', value: 2.0, femaleValue: 1.0 },
    { year: '2011-12', value: 4.0, femaleValue: 2.5 },
    { year: '2022-23', value: 8.5, femaleValue: 4.0 },
  ];

  const exportMarkets = [
    { country: 'Australia', value: 100 },
    { country: 'Turkey', value: 85 },
    { country: 'US', value: 50 },
    { country: 'Singapore', value: 30 },
    { country: 'Maldives', value: 20 },
    { country: 'UK', value: 10 },
  ];

  const globalExports = [
    { product: 'Product 1', quantity: 82324, value: 285.92 },
    { product: 'Product 2', quantity: 62097, value: 282.05 },
    { product: 'Product 3', quantity: 74012, value: 276.19 },
    { product: 'Product 4', quantity: 64311, value: 270.02 },
    { product: 'Product 5', quantity: 45789, value: 250.15 },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        {/* Sizing Constraints Section */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Set sizing constraints</h2>
          
          <div style={styles.filterGroup}>
            <div style={styles.filterTitle}>
              <span>ITEM CATEGORY</span>
            </div>
            <div style={styles.chipGroup}>
              <button style={{...styles.chip, ...styles.activeChip}}>Female Apparels</button>
              <button style={{...styles.chip, ...styles.activeChip}}>Male Apparels</button>
              <button style={{...styles.chip, ...styles.inactiveChip}}>Children's Apparel</button>
              <button style={{...styles.chip, ...styles.inactiveChip}}>Accessories</button>
            </div>
          </div>

          <div style={styles.filterGroup}>
            <div style={styles.filterTitle}>REGION</div>
            <table style={styles.regionTable}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>State</th>
                  <th style={styles.tableHeader}>Urban</th>
                  <th style={styles.tableHeader}>Rural</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.tableCell}>Andhra Pradesh</td>
                  <td style={styles.tableCell}><input type="checkbox" checked style={styles.checkbox} /></td>
                  <td style={styles.tableCell}><input type="checkbox" checked style={styles.checkbox} /></td>
                </tr>
                <tr>
                  <td style={styles.tableCell}>Arunachal Pradesh</td>
                  <td style={styles.tableCell}><input type="checkbox" checked style={styles.checkbox} /></td>
                  <td style={styles.tableCell}><input type="checkbox" checked style={styles.checkbox} /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={styles.formula}>
            <div style={styles.formulaTitle}>Formula for calculating market size by region and sector</div>
            <div style={styles.formulaItem}>
              Number of Households <button style={styles.closeButton}>×</button>
            </div>
            <div style={styles.formulaItem}>
              Household Size <button style={styles.closeButton}>×</button>
            </div>
            <div style={styles.formulaItem}>
              Average MPCE <button style={styles.closeButton}>×</button>
            </div>
            <div style={styles.formulaItem}>
              Monthly Per Capita Category Expenditure % <button style={styles.closeButton}>×</button>
            </div>
          </div>
        </div>

        {/* Trend Chart Section */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Trend in percentage composition of MPCE since 1999-'00</h2>
          {/* <LineChart width={500} height={300} data={trendData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="value" stroke="#8884d8" />
            <Line type="monotone" dataKey="femaleValue" stroke="#82ca9d" />
          </LineChart> */}
        </div>

        {/* Export Markets Section */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Top Markets to Export</h2>
          <div>
            <h3 style={{...styles.sectionTitle, fontSize: '14px'}}>Product 1</h3>
            {exportMarkets.map((market, index) => (
              <div key={index}>
                <div style={styles.barLabel}>{market.country}</div>
                <div style={{...styles.bar, width: `${market.value}%`}} />
              </div>
            ))}
          </div>
        </div>

        {/* Global Exports Table */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>GLOBAL EXPORTS</h2>
          <table style={styles.regionTable}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>Product</th>
                <th style={styles.tableHeader}>Quantity (Ton)</th>
                <th style={styles.tableHeader}>Value (US $ MM)</th>
              </tr>
            </thead>
            <tbody>
              {globalExports.map((item, index) => (
                <tr key={index}>
                  <td style={styles.tableCell}>{item.product}</td>
                  <td style={styles.tableCell}>{item.quantity.toLocaleString()}</td>
                  <td style={styles.tableCell}>{item.value.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};


export default CategorySize;
